import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { useAuth } from "../common/context/clientContext";
import { axiosPost } from "../common/services/axios/apiCalls"
import SetLoading from "../common/components/modals/setLoadingModal";
import Footer from "../common/components/footer/footer";

import MenuBar from "../components/menuBar/menuBar";
import ProductCard from "../components/card/productCard"

export default function DevicePage({ additionalParams }) {
    /** CONST */
    const navigate = useNavigate();
    const { user, token, setUser, setToken } = useAuth()
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([])
    const [propertiesData, setPropertiesData] = useState([])
    const [productData, setProductData] = useState({})
    const [edit, setEdit] = useState(false);
    const [draft, setDraft] = useState(false);
    const [published, setPublished] = useState(false);

    /** PARAMS */
    const { id } = useParams();

    const getCatalogUsername = async () => {
        const axiosData = {
            code: `${process.env.REACT_APP_COMPANY}`
        }

        try {
            const response = await axiosPost("/public/catalog/category/read", token, axiosData)
            return response.data
        } catch (error) {
            setLoading(false);
            navigate('/notfound?message=ApiError');
        }
    }

    const getProductById = async () => {
        const axiosData = {
            code: id,
        }

        try {
            const response = await axiosPost("/public/product/read/details", token, axiosData)
            return response.data
        } catch (error) {
        }
    }

    const getProperties = async (type) => {
        const axiosData = { type }

        try {
            const response = await axiosPost("/public/product/get/type/properties", token, axiosData)
            return response.data
        } catch (error) {
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            setCategories(await getCatalogUsername())
            if (id) {
                // Encontrar Producto
                const productDetails = await getProductById()
                if (!productDetails) {
                    setProductData(null)
                    setLoading(false);
                    return;
                }
                setProductData(productDetails)

                // Encontrar properties
                const properties = await getProperties(productDetails.type.code)

                setPropertiesData(properties)
            }

            setLoading(false);
        };

        fetchData();
    }, [id])

    return (
        <div className="d-flex flex-column min-vh-100">
            {loading && <SetLoading />}
            {!loading && categories &&
                <>
                    <div className="flex-grow-1">
                        <MenuBar menuItems={categories} />
                        {propertiesData && productData &&
                            <div className="container-xxl">
                                <ProductCard productData={productData} properties={propertiesData} />
                            </div>
                        }
                    </div>
                    <Footer />
                </>
            }
        </div>
    );
}
